/* eslint-disable react/style-prop-object */
import * as React from "react";
import { Dialog } from "@emisgroup/ui-dialog";
import { Button, ButtonGroup } from "@emisgroup/ui-button";
import { ShowPassword } from "@emisgroup/icons-react";
import { useTranslation } from "@emisgroup/application-intl";
import VisibilityRuleViewer from "./visibilityRuleViewer";

import "./visibilityRuleIndicator.css";

type RuleViewerDialogProps = { children: React.ReactNode | React.ReactNodeArray; onClose: () => void };
function RuleViewerDialog({ children, onClose }: RuleViewerDialogProps) {
    return (
        <Dialog open={true} onOpenChange={onClose} preventBackdropClose>
            <Dialog.Inner className="auto-sized-dialog dialog_layer">
                <Dialog.Header closeButtonTitle="Visibility rule viewer">Visibility rule viewer</Dialog.Header>
                <Dialog.Content>{children}</Dialog.Content>
                <Dialog.Footer>
                    <ButtonGroup>
                        <Button data-testid="close-viewer" type="button" variant="filled" onClick={onClose}>
                            Close
                        </Button>
                    </ButtonGroup>
                </Dialog.Footer>
            </Dialog.Inner>
        </Dialog>
    );
}

type VisibilityRuleIndicatorProps = { componentId: string; optionValue?: string; dataTestId?: string };
export default function VisibilityRuleIndicator({
    componentId,
    optionValue,
    dataTestId,
}: VisibilityRuleIndicatorProps) {
    const [showRuleViewer, setShowRuleViewer] = React.useState(false);
    const { t } = useTranslation();

    return (
        <>
            <button
                type="button"
                className="rules-button"
                data-testid={dataTestId}
                onClick={() => setShowRuleViewer(true)}
            >
                <ShowPassword title={t("propertyInspector.affectsVisibilityRules")} />
            </button>
            {showRuleViewer && (
                <RuleViewerDialog onClose={() => setShowRuleViewer(false)}>
                    <VisibilityRuleViewer componentId={componentId} optionValue={optionValue} />
                </RuleViewerDialog>
            )}
        </>
    );
}
